export function buildMfaStartParam(id: string) {
  return `m_${id}`;
}
